import React from 'react';
import { Link } from 'react-router-dom';

const SingleItem = ({ data, handleEnableDisabled }) => {



    return (
        <>
            <tr>
                <td data-label="Name">{data?.name}</td>
                <td data-label="Image">
                    <div className="user" >
                        <div className="thumb">
                            <img src={`https://api.wlfmobile.com/${data?.image}`} alt='' />
                        </div>
                        <span className="name"></span>
                    </div>
                </td>
                <td data-label="Symbol">{data?.symbol}</td>
                <td data-label="Status">
                    {data?.status === 1 ?
                        <span className="badge badge--success text-success">Enabled</span>
                        :
                        <span><span class="badge badge--warning text-warning">Disabled</span></span>
                    }
                </td>
                <td data-label="Action">
                    <Link to={`/admin/indices/edit/${data._id}`} className="btn btn-sm btn-outline-primary editBtn"
                    >
                        <i className="la la-pencil"></i>Edit
                    </Link>

                    {data?.status === 1 ?
                        <button onClick={() => handleEnableDisabled(data._id)} className="btn btn-sm btn-outline-danger ms-1 confirmationBtn"
                        >
                            <i className="la la-eye-slash"></i>Disable
                        </button>
                        :

                        <button onClick={() => handleEnableDisabled(data._id)} className="btn btn-sm btn-outline-success ms-1 confirmationBtn"
                        >
                            <i className="la la-eye"></i> Enable
                        </button>
                    }


                </td>
            </tr>

        </>
    );
};

export default SingleItem;